<template>
  <div
    class="single-sample"
    :class="{ 'mb-3': !hidePortions }"
  >
    <b-button
      class="d-flex justify-content-between"
      :class="{ 'attach-pressed': btnPressed }"
    >
      <div
        class="d-flex align-items-center flex-fill"
        @click="elementSelected"
      >
        <i
          class="far fa-prescription-bottle primary-dark-color mr-2"
          aria-hidden="true"
        />
        <span>{{ sample.samSampleNumber }}</span>
        <vtBubble
          v-if="sample.attachmentsCount"
          :number="sample.attachmentsCount"
          :type="false"
          :tooltip="' '+$tc('global.file',2)"
          style="margin-top: 2px"
        />
      </div>
      <div
        v-show="showArrow"
        class="attach-arrow"
        @click="hidePortions = !hidePortions"
      >
        <i
          v-show="hidePortions"
          class="far fa-chevron-down"
          aria-hidden="true"
        />
        <i
          v-show="!hidePortions"
          class="far fa-chevron-up"
          aria-hidden="true"
        />
      </div>
    </b-button>

    <div
      v-for="(portion, portionIndex) in sample.portions"
      :key="portionIndex"
      class="element portions ml-2"
      :class="{'attach-display': hidePortions}"
    >
      <portion-tree
        ref="portionTree"
        :case-id="caseId"
        :sample-id="entityId"
        :laboratory-id="laboratoryId"
        :sample-number="sample.samSampleNumber"
        :portion="portion"
        @child-selected="$emit('child-selected', $event)"
      />
    </div>
  </div>
</template>

<script>
import PortionTree from './PortionTree'
import VtBubble from '@/components/common/VtBubble'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'

export default {
    name: 'SampleTree',
    components: {
        VtBubble,
        PortionTree
    },
    mixins: [
        SampleOperationGuardMixin
    ],
    props: {
        laboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true },
        sample: { type: Object, required: true }
    },
    data() {
        return {
            selectedCaseId: null,
            showArrow: true,
            hidePortions: false,
            btnPressed: false,
            attachments: [],
            elementIcon: 'fa-prescription-bottle',
            attachmentEntityType: ATTACHMENT_ENTITY_TYPE.SAMPLE
        }
    },
    computed: {
        entityId() {
            return this.sample.samId
        },
        entityDisplay() {
            return this.sample.samLabel
        },
        sampleId() {
            return this.sample.samId
        },
        userHasAttachOperation() {
            return this.$_canAttachDocumentToSample()
        },
        canBeAttached() {
            return this.$_canBeDocumentAttachedToSample(this.sample)
        }
    },
    methods: {
        async elementSelected() {
            this.btnPressed = true
            this.attachments = await sampleAttachmentService.getAttachments(this.laboratoryId, this.caseId, this.entityId)
            this.$emit('child-selected', this)
        },
        deselect() {
            this.btnPressed = false
        },
        findPortionTree(portionId) {
            return this.$refs.portionTree?.find((child) => child.entityId === portionId)
        },
        findSubportionTree(subportionId) {
            if (this.$refs.portionTree) {
                for (const portionTree of this.$refs.portionTree) {
                    const subportionTree = portionTree.findSubportionTree(subportionId)
                    if (subportionTree) {
                        return subportionTree
                    }
                }
            }
        }
    }
}
</script>
